import { apiClient } from '@/api/core/apiClient.ts';
import { API_CONFIG } from '@/api/core/apiConfig.ts';
import type { ApiResponse } from '@/api/shared/types.ts';
import type { LC_GetAsyncJobProcessesCatalogOut, AsyncJobProcess } from './asyncJobProcess.types.ts';
import { mapAsyncJobProcessOutToModel } from './asyncJobProcess.mapper.ts';


export class AsyncJobProcessCatalogService {
  async getAsyncJobProcesses(signal?: AbortSignal): Promise<ApiResponse<AsyncJobProcess[]>> {
    const response = await apiClient.get<LC_GetAsyncJobProcessesCatalogOut>(
      API_CONFIG.ENDPOINTS.CATALOG.ASYNC_JOB_PROCESSES,
      { signal },
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapAsyncJobProcessOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const asyncJobProcessCatalogService = new AsyncJobProcessCatalogService();
